import React from 'react';
import { Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';

export default function ProjectCard({
  project,
}: {
  project: Queries.IndexPageQuery['allMarkdownRemark']['edges'][0]['node']['frontmatter'];
}) {
  if (!project || !project.thumbnail) return null;

  const { key, title, subtitle, demoOnly, demo, thumbnail } = project;

  return (
    <div className="project-block">
      <div className="project-mask" />
      <div className="project-thumbnail">
        <div className="img-wrapper">
          <div className="img-fake-wrapper">
            {'childImageSharp' in thumbnail && thumbnail?.childImageSharp ? (
              <GatsbyImage alt="Project thumbnail" image={thumbnail.childImageSharp.gatsbyImageData} />
            ) : (
              <img src={thumbnail.publicURL || undefined} alt={subtitle || undefined} />
            )}
          </div>
        </div>
      </div>
      <div className="project-label">
        <div className="name">{title}</div>
        <div className="title">
          <p>
            <small>{subtitle}</small>
          </p>
        </div>
        <div className="description">
          <p>
            {!demoOnly && (
              <Link to={`/projects/${key}`} className="project-button">
                Project page
              </Link>
            )}
            {demo && (
              <a href={demo} target="_blank" rel="noopener noreferrer" className="project-button">
                Demo
              </a>
            )}
          </p>
        </div>
      </div>
    </div>
  );
}
